module.exports = __webpack_public_path__ + "media/b.e4ed5cb5.mp4";